// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-page-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  padding: var(--spacing-regular);
  height: 100%;
  cursor: auto;
}
.checkout-page-wrapper .checkout-page {
  display: flex;
  gap: var(--spacing-small);
}
.checkout-page-wrapper .checkout-page .checkout-page-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
.followup-button {
  min-width: 100%;
  margin-bottom: 4px;
}
@media screen and (max-width: 768px) {
  .checkout-page-wrapper {
    padding: var(--spacing-small);
  }
  .checkout-page-wrapper .checkout-page {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-small);
  }
  .checkout-page-wrapper .checkout-page .checkout-page-content-wrapper.col {
    flex-basis: auto;
  }
  .checkout-page-wrapper .checkout-page .payment-summary-button {
    width: 100%;
  }
  .checkout-page-wrapper .checkout-page .payment-summary-disclaimer {
    font-weight: 400 !important;
    font-size: var(--font-small);
    margin-top: 2%;
  }
}
.box-method-payment .vert-radio .ant-radio-wrapper.ant-radio-wrapper-disabled > span,
.box-method-payment .vert-radio-group .ant-radio-wrapper.ant-radio-wrapper-disabled > span,
.box-method-payment .vert-radio-group.ant-radio-wrapper.ant-radio-wrapper-disabled > span,
.box-method-payment .vert-radio.ant-radio-wrapper.ant-radio-wrapper-disabled > span {
  display: flex;
  align-items: center;
}
.box-method-payment .vert-radio .ant-radio-wrapper .ant-radio + span,
.box-method-payment .vert-radio-group .ant-radio-wrapper .ant-radio + span,
.box-method-payment .vert-radio-group.ant-radio-wrapper .ant-radio + span,
.box-method-payment .vert-radio.ant-radio-wrapper .ant-radio + span {
  padding-left: 5px;
  display: flex;
  align-items: center;
}
.box-checkout-difal {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.payment-summary-disclaimer {
  font-weight: 400 !important;
  font-size: var(--font-small);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/checkout/CheckoutStyles.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,+BAAA;EACA,YAAA;EAEA,YAAA;AADF;AANA;EAUI,aAAA;EACA,yBAAA;AADJ;AAVA;EAcM,aAAA;EACA,sBAAA;EACA,yBAAA;AADN;AAMA;EACE,eAAA;EACA,kBAAA;AAJF;AAQA;EACE;IACE,6BAAA;EANF;EAKA;IAII,aAAA;IACA,sBAAA;IACA,yBAAA;EANJ;EASM;IACE,gBAAA;EAPR;EAHA;IAeM,WAAA;EATN;EANA;IAmBM,2BAAA;IACA,4BAAA;IACA,cAAA;EAVN;AACF;AAeA;;;;EAMI,aAAA;EACA,mBAAA;AAfJ;AAQA;;;;EAcI,iBAAA;EACA,aAAA;EACA,mBAAA;AAhBJ;AAoBA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAlBF;AAqBA;EACE,2BAAA;EACA,4BAAA;AAnBF","sourcesContent":["// DESKTOP\n.checkout-page-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-regular);\n  padding: var(--spacing-regular);\n  height: 100%;\n\n  cursor: auto;\n\n  .checkout-page {\n    display: flex;\n    gap: var(--spacing-small);\n\n    .checkout-page-content-wrapper {\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing-small);\n    }\n  }\n}\n\n.followup-button {\n  min-width: 100%;\n  margin-bottom: 4px;\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .checkout-page-wrapper {\n    padding: var(--spacing-small);\n\n    .checkout-page {\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing-small);\n\n      .checkout-page-content-wrapper {\n        &.col {\n          flex-basis: auto;\n        }\n      }\n\n      .payment-summary-button {\n        width: 100%;\n      }\n\n      .payment-summary-disclaimer {\n        font-weight: 400 !important;\n        font-size: var(--font-small);\n        margin-top: 2%;\n      }\n    }\n  }\n}\n\n.box-method-payment {\n\n  .vert-radio .ant-radio-wrapper.ant-radio-wrapper-disabled>span,\n  .vert-radio-group .ant-radio-wrapper.ant-radio-wrapper-disabled>span,\n  .vert-radio-group.ant-radio-wrapper.ant-radio-wrapper-disabled>span,\n  .vert-radio.ant-radio-wrapper.ant-radio-wrapper-disabled>span {\n    display: flex;\n    align-items: center;\n  }\n\n  .vert-radio .ant-radio-wrapper .ant-radio+span,\n  .vert-radio-group .ant-radio-wrapper .ant-radio+span,\n  .vert-radio-group.ant-radio-wrapper .ant-radio+span,\n  .vert-radio.ant-radio-wrapper .ant-radio+span {\n    padding-left: 5px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.box-checkout-difal {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.payment-summary-disclaimer {\n  font-weight: 400 !important;\n  font-size: var(--font-small);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
